import React from 'react';
import { Helmet } from "react-helmet";
import CarouselGolden from './CarouselGolden';
import { Tabs, Tab, Row, Col } from 'react-bootstrap';
import VideoList from './VideoList';
import './Births.css';

//import spey_1 from './video/spey_1.mp4';

const images = require.context('./img/golden/naissance/naissance_old', true);
const imageList = images.keys().map(image => images(image));

/*const images_speyburn = require.context('./img/golden/naissance/naissance_speyburn/current', true);
const imageList2 = images_speyburn.keys().map(image => images_speyburn(image));
const videos_spey = [spey_1]

const images_usher = require.context('./img/golden/naissance/naissance_usher/current', true);
const imageList3 = images_usher.keys().map(image => images_usher(image));*/


const Births = () => {
  return (
    <div className="container">
      <Helmet>
        <title>Dernières naissances de chiots golden retriever</title>
        <meta
          name="description"
          content="Retrouvez l'actualité des dernières naissances de chiots golden retriever de travail dans le Puy-de-dôme de l'élevage au travers de photos et de vidéos."
        />
      </Helmet>
      <h1 className='mb-3'>Carnet de naissances</h1>
      <p className='mt-3 mb-3'>
        Vous pouvez suivre les dernières naissances sur notre page <a href="https://www.facebook.com/people/%C3%89levage-des-Bruy%C3%A8res-de-Servi%C3%A8re/100057480758331/">facebook</a>.
      </p>
      {/*<Tabs>
        <Tab eventKey="Speyburn" title="Speyburn">
          <Row>
            <Col>
              <Row>
                <p className='mt-3 mb-3'>
                  Les 11 chiots de Speyburn et Tommy sont arrivés le 30 avril.
                </p>
              </Row>
            <Row>
                <VideoList videos={videos_spey} nom="Speyburn"/>
              </Row>
            </Col>
            <Col>
              <div className='d-flex justify-content-center'>
                <CarouselGolden imageList={imageList2} />
              </div>
            </Col>
          </Row>
        </Tab>
        <Tab eventKey="Usher" title="Usher">
          <Row>
            <Col>
              <Row>
                <p className='mt-3 mb-3'>
                  Les 5 chiots de Usher et Tommy sont arrivés le 8 mai.
                </p>
              </Row>
            {<Row>
                <VideoList videos={videos_scapa} nom="Scapa"/>
              </Row>}
            </Col>
            <Col>
              <div className='d-flex justify-content-center'>
                <CarouselGolden imageList={imageList3} />
              </div>
            </Col>
          </Row>
        </Tab>
      </Tabs>*/}
      <div className='d-flex justify-content-center h-100 w-100 sep'>
        <CarouselGolden imageList={imageList} cN='w-50'/>
      </div>
      <p className='d-flex justify-content-center mt-3'>
        Photos des anciennes portées.
      </p>
    </div>
  );
};

export default Births;
